export enum BackgroundType {
  Image = 0,
  Color = 1,
}
